import { IApiService } from '../../services/ApiService';
import { LoaderFunctionArgs } from 'react-router';
import { handleLoaderError } from '../../services/loaderErrorHandler';
import { Logger } from '../../utils/Logger';

export function bailleursPageLoader(apiService: IApiService) {
  return async ({ request }: LoaderFunctionArgs) => {
    Logger.debug('LOADER', "bailleurs loader starting");
    try {
      const bailleurs = await apiService.getBailleurs(request.signal);
      Logger.debug('LOADER', "bailleurs loader completed with", bailleurs.length, "bailleurs");
      return { bailleurs };
    } catch (error) {
      return handleLoaderError(error, request.url);
    }
  };
}
